import type { ReactNode } from "react";
import { cn } from "@shared/lib/utils";

/**
 * Courtyard 참조값 칩("FMV $x" 상응) — 가격은 단독 숫자 금지, 항상 기준값과 쌍 (_common §2).
 * 값 미확정은 "FMV —"(자리 예약). TODO(server): FMV 시세 피드 연결 시 value 채움.
 */
export function RefChip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      title="Fair market value — published at release"
      className={cn(
        "inline-flex shrink-0 items-center rounded-full border border-line px-2 py-0.5 align-middle font-mono text-[10px] font-medium tabular-nums text-ink-mute",
        className,
      )}
    >
      {children}
    </span>
  );
}
